export const twoDigits = num => (num < 0 ? "-" : "") + (Math.abs(num) < 10 ? "0" : "") + String(num);

export const fourDigits = num =>
  (num < 0 ? "-" : "") +
  (Math.abs(num) < 10 ? "000" : Math.abs(num) < 100 ? "00" : Math.abs(num) < 1000 ? "0" : "") +
  String(num);
